import { createContext, useCallback, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import EventEmitter from "events";


const scrollStateDict = new Map();
const pageStateDict = new Map();
const stateEvents = new EventEmitter();

let debounceTimer = null;

const triggerStateRestore = (pathname) => {
  if (scrollStateDict.has(pathname)) {
    const scrollState = scrollStateDict.get(pathname);
    scrollStateDict.delete(pathname);

    requestAnimationFrame(() => {
      stateEvents.emit("restoreScrollState", scrollState);
    });
  }

  if (pageStateDict.has(pathname)) {
    requestAnimationFrame(() => {
      let entry = pageStateDict.get(pathname);
      //pageStateDict.delete(pathname);

      let keys = Object.keys(entry);
  
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        stateEvents.emit(`restorePageState:${key}`, entry[key]);
      }
    });
  }
}

window.addEventListener("popstate", () => triggerStateRestore(window.location.pathname));

export const NavStateContext = createContext();

export const useNavState = () => useContext(NavStateContext);

export const NavStateProvider = (props) => {
  const location = useLocation();
  const pathname = location.pathname;
  const pathRef = useRef(pathname);

  useEffect(() => {
    if (
      pathRef.current !== pathname &&
      pathRef.current.startsWith(pathname)
    ) {
      triggerStateRestore(pathname);
    }

    pathRef.current = pathname;
  }, [pathname]);

  const registerScrollState = useCallback((scrollTop, scrollHeight) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => scrollStateDict.set(pathname, { scrollTop, scrollHeight }), 50);
  }, [pathname]);

  const registerPageState = useCallback((key, data) => {
    // TODO find way we can register multiple values here, based on key
    
    if (pageStateDict.has(pathname)) {
      let entry = pageStateDict.get(pathname);
      entry[key] = data;
    } else {
      pageStateDict.set(pathname, { [key]: data });
    }
    
  }, [pathname]);

  return (
    <NavStateContext.Provider
      value={{
        registerScrollState,
        registerPageState,
        stateEvents
      }}
    >
      {props.children}
    </NavStateContext.Provider>
  );
};




